/**
 * Decides the language Firebase Auth uses for the emails it sends (verification,
 * password reset). The language selected in the app wins; when the app has none
 * (no user preference and the detector found nothing), Firebase follows the
 * browser's language instead.
 *
 * Firebase's stock templates exist per language and are picked by
 * `auth.languageCode`; a custom template body in the console applies to every
 * language, so keep the console templates stock to get per-user languages.
 */
export interface EmailLanguageAuth {
  languageCode: string | null;
  useDeviceLanguage(): void;
}

export function applyEmailLanguage(auth: EmailLanguageAuth, appLanguage?: string | null): void {
  const base = (appLanguage || '').split('-')[0].trim();
  if (base) {
    auth.languageCode = base;
  } else {
    auth.useDeviceLanguage();
  }
}
